<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    if ('/login' !== this.$route.path) {
      // 不是登录界面，则要检查当前用户（后续可能还要排除注册界面）
      console.log(' user = ', this.$store.getters.user)
      if (!this.$store.getters.user) {
        console.log('当前上下文找不到用户信息，可能未登录或登录失效，跳转到登录页面');
        this.$router.push('/login')
      }
    }
  },
}
</script>

<style scoped>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue